export const apiUrl = process.env.REACT_APP_API_BASE_URL;

function value4query(key, value) {
  if (value === null || value === undefined) {
    return "";
  }

  return value; //encodeURIComponent(value);
}

export async function serverFetch(address, options) {
  const sessionId = localStorage.getItem("sessionId");
  options = options || {};
  let url = new URL(`${apiUrl}/api/${address}`);
  Object.keys(options.queryParams || {}).forEach((key) => {
    if (Array.isArray(options.queryParams[key])) {
      options.queryParams[key].map((value) =>
        url.searchParams.append(key, value4query(key, value)),
      );
    } else {
      url.searchParams.append(key, value4query(key, options.queryParams[key]));
    }
  });

  let init = {
    method: "GET",
    ...options,
    headers: options.body
      ? new Headers()
      : new Headers({
          accept: "application/json",
          "Content-Type": "application/json-patch+json",
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
        }),
  };

  if (sessionId) {
    init.headers.append("SessionId", sessionId);
  }

  if (options.bodyData != null) {
    init.body = JSON.stringify(options.bodyData);
  }

  if (options.headers) {
    Object.keys(options.headers).forEach((key) => {
      init.headers.append(key, options.headers[key]);
    });
  }

  let response;
  try {
    response = await fetch(url, init);
  } catch (exc) {
    throw new Error("Error parsing response body");
  }

  if (response.ok && response.status === 204) {
    return;
  }

  let responseContentPromise;
  // console.log(response.headers.get('content-type'))

  if (!response.ok || options.rawResponse) {
    responseContentPromise = response.text();
  } else if (options.download || options.blob) {
    responseContentPromise = response.blob();
  } else if (response.headers.get("content-type").includes("text/")) {
    responseContentPromise = response.text();
  } else {
    responseContentPromise = response.json();
  }

  let content;
  try {
    content = await responseContentPromise;
  } catch (exc) {
    throw new Error("Error parsing response body");
  }

  if (response.ok) {
    return content;
  }

  if (!content) {
    content = {
      status: response.status,
      message: response.statusText,
    };
  } else if (typeof content == "string") {
    try {
      content = JSON.parse(content);
    } catch (e) {}
  }
  throw content;
}
